import { BarChart3, Eye, Bell, Users } from "lucide-react";

const tabs = [
  { id: "summary", icon: BarChart3, label: "Summary" },
  { id: "observations", icon: Eye, label: "Observations" },
  { id: "alerts", icon: Bell, label: "Alerts" },
  { id: "collaborators", icon: Users, label: "Collaborators" },
];

export default function BottomNav({ activeTab, setActiveTab }) {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-xl border-t border-[#E2DFD8]/50 z-50" style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}>
      <div className="max-w-lg mx-auto grid grid-cols-4 px-1 pt-1.5 pb-3">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            data-testid={`nav-${tab.id}`}
            onClick={() => setActiveTab(tab.id)}
            className={`flex flex-col items-center justify-center gap-0.5 transition-all duration-300 ${
              activeTab === tab.id
                ? "text-[#8E9B82]"
                : "text-[#6B7264]/40 hover:text-[#6B7264]/70"
            }`}
          >
            <div className={`flex items-center justify-center w-8 h-7 rounded-lg transition-all ${activeTab === tab.id ? "bg-[#8E9B82]/10" : ""}`}>
              <tab.icon size={19} strokeWidth={1.5} />
            </div>
            <span className="text-[10px] font-manrope font-medium leading-none">{tab.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
